import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../library/button/button';
import { ExchangeAltSolidIcon } from '../../../../shared/icons/icons';
import BundleItemProductDescription from '../../../bundle-item-product-description/bundle-item-product-description';
import ModifyEntryConfirmation, {
  ACTIONS
} from '../../../modify-entry-confirmation/modify-entry-confirmation';
import StaggeredPackageDescription from '../staggered-package-description/staggered-package-description';

import { isStaggeredPackageGroupEntry } from '../../../../shared/utils/cart/cart';
import { getNormalizedProductType } from '../../../../shared/utils/product/product';

import { ENTRY_TYPES } from '../../../../shared/constants/cart';
import { PRODUCT_TYPES } from '../../../../shared/constants/products';

import styles from './tire-wheel-package-description.scss';

function TireWheelPackageDescription(props) {
  const {
    groupEntry,
    hideChangeProduct,
    isReadOnly,
    onCancel,
    onChangeProduct,
    onChangeProductInBundle,
    onConfirmChangeProduct,
    pendingAction,
    requireConfirmation,
    shouldShowCartPrice = false
  } = props;

  const { entries } = groupEntry || {};

  const isEditingFirstEntry = pendingAction?.entryIndex === 0;
  const isEditingSecondEntry = pendingAction?.entryIndex === 1;

  const isStaggered = isStaggeredPackageGroupEntry(groupEntry);

  if (isStaggered) {
    const firstSetType =
      getNormalizedProductType(entries[0].product) === PRODUCT_TYPES.TIRES
        ? PRODUCT_TYPES.TIRES
        : PRODUCT_TYPES.WHEELS;

    return (
      <div>
        {isEditingFirstEntry && (
          <ModifyEntryConfirmation
            action={pendingAction.type}
            onCancel={onCancel}
            onConfirm={onConfirmChangeProduct}
            productType={firstSetType}
          />
        )}
        {!isEditingFirstEntry && isStaggered && (
          <>
            <StaggeredPackageDescription
              groupEntry={{
                entries: entries.filter(
                  e => getNormalizedProductType(e.product) === firstSetType
                ),
                entryType: ENTRY_TYPES.STAGGERED
              }}
              hideChangeProduct
              isPackage
              isReadOnly
              onCancel={onCancel}
              onChangeProduct={onChangeProduct}
              onConfirmChangeProduct={onConfirmChangeProduct}
              productType={getNormalizedProductType(entries[0].product)}
              requireConfirmation={requireConfirmation}
              shouldShowCartPrice={shouldShowCartPrice}
            />

            {!hideChangeProduct && (
              <div className={styles['ctas']}>
                {onChangeProductInBundle && !hideChangeProduct && (
                  <Button
                    icon={ExchangeAltSolidIcon}
                    onClick={() => onChangeProduct(ACTIONS.CHANGE, 0, true)}
                  >
                    change{' '}
                    {firstSetType === PRODUCT_TYPES.TIRES
                      ? 'tire set'
                      : 'wheel set'}
                  </Button>
                )}
              </div>
            )}
          </>
        )}
        {isEditingSecondEntry && (
          <ModifyEntryConfirmation
            action={pendingAction.type}
            onCancel={onCancel}
            onConfirm={onConfirmChangeProduct}
            productType={
              firstSetType === PRODUCT_TYPES.TIRES
                ? PRODUCT_TYPES.WHEELS
                : PRODUCT_TYPES.TIRES
            }
          />
        )}
        {!isEditingSecondEntry && (
          <>
            <StaggeredPackageDescription
              groupEntry={{
                entries: entries.filter(
                  e =>
                    getNormalizedProductType(e.product) ===
                    (firstSetType === PRODUCT_TYPES.TIRES
                      ? PRODUCT_TYPES.WHEELS
                      : PRODUCT_TYPES.TIRES)
                ),
                entryType: ENTRY_TYPES.STAGGERED
              }}
              hideChangeProduct
              isReadOnly
              onCancel={onCancel}
              onChangeProduct={onChangeProduct}
              onConfirmChangeProduct={onConfirmChangeProduct}
              productType={getNormalizedProductType(entries[1].product)}
              requireConfirmation={requireConfirmation}
              shouldShowCartPrice={shouldShowCartPrice}
            />
            {!hideChangeProduct && (
              <div className={styles['ctas']}>
                {onChangeProductInBundle && !hideChangeProduct && (
                  <Button
                    icon={ExchangeAltSolidIcon}
                    onClick={() => onChangeProduct(ACTIONS.CHANGE, 1, true)}
                  >
                    change{' '}
                    {firstSetType === PRODUCT_TYPES.TIRES
                      ? 'wheel set'
                      : 'tire set'}
                  </Button>
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  return (
    <div>
      <div className={styles['package-entries']}>
        {isEditingFirstEntry && (
          <ModifyEntryConfirmation
            action={pendingAction.type}
            onCancel={onCancel}
            onConfirm={onConfirmChangeProduct}
            productType={getNormalizedProductType(entries[0].product)}
          />
        )}
        {!isEditingFirstEntry && (
          <BundleItemProductDescription
            className={styles['first-package-entry']}
            entry={entries?.[0]}
            hideChangeProduct={isReadOnly || hideChangeProduct}
            isPackage
            isPriceForEach
            onChangeProduct={() => onChangeProduct(ACTIONS.CHANGE, 0)}
            shouldShowCartPrice={shouldShowCartPrice}
            showMinimumPriceMessage
          />
        )}
        {isEditingSecondEntry && (
          <ModifyEntryConfirmation
            action={pendingAction.type}
            onCancel={onCancel}
            onConfirm={onConfirmChangeProduct}
            productType={getNormalizedProductType(entries[1].product)}
          />
        )}
        {!isEditingSecondEntry && (
          <BundleItemProductDescription
            className={styles['package-entry']}
            entry={entries?.[1]}
            hideChangeProduct={isReadOnly || hideChangeProduct}
            isPackage
            isPriceForEach
            onChangeProduct={() => onChangeProduct(ACTIONS.CHANGE, 1)}
            shouldShowCartPrice={shouldShowCartPrice}
            showMinimumPriceMessage
          />
        )}
      </div>
    </div>
  );
}

TireWheelPackageDescription.propTypes = {
  groupEntry: PropTypes.object,
  hideChangeProduct: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  onCancel: PropTypes.func,
  onChangeProduct: PropTypes.func,
  onChangeProductInBundle: PropTypes.func,
  onConfirmChangeProduct: PropTypes.func,
  pendingAction: PropTypes.object,
  requireConfirmation: PropTypes.bool,
  shouldShowCartPrice: PropTypes.bool
};

export default TireWheelPackageDescription;
